import { useState } from "react";
import { PageHero } from "@/components/Sections";
import { planets } from "@/data/planets";

export default function PlanetFacts() {
  const [active, setActive] = useState(planets[2]);

  return (
    <>
      <PageHero
        eyebrow="Planet Facts"
        title="Eight worlds, one"
        accent="Solar System."
        subtitle="Each planet in our cosmic neighborhood is wildly different — frozen worlds, gas giants, and the only place we know of with life."
      />

      <section className="max-w-7xl mx-auto px-6 pb-12">
        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3 stagger">
          {planets.map((p) => (
            <button
              key={p.name}
              onClick={() => setActive(p)}
              data-testid={`planet-pill-${p.name.toLowerCase()}`}
              className={`glass hover-lift p-4 flex flex-col items-center gap-3 ${active.name === p.name ? "border-white/30" : ""}`}
            >
              <div className="planet-sphere" style={{ width: 56, height: 56, background: p.gradient, "--glow": p.glow }} />
              <span className="text-sm font-medium">{p.name}</span>
            </button>
          ))}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 pb-24">
        <div className="glass-strong p-6 md:p-12 fade-in-up" data-testid="planet-detail" key={active.name}>
          <div className="grid lg:grid-cols-12 gap-12 items-center">
            <div className="lg:col-span-5 flex justify-center">
              <div
                className="planet-sphere"
                style={{ width: 280, height: 280, background: active.gradient, "--glow": active.glow }}
              />
            </div>
            <div className="lg:col-span-7">
              <div className="eyebrow">{active.type}</div>
              <h2 className="display mt-4 text-5xl md:text-6xl lg:text-7xl">{active.name}</h2>
              <p className="mt-5 text-white/70 text-base md:text-lg leading-relaxed">{active.description}</p>

              <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-5">
                <Spec label="Distance" value={active.distance} />
                <Spec label="Moons" value={active.moons} />
                <Spec label="Day length" value={active.day} />
                <Spec label="Year length" value={active.year} />
              </div>

              <div className="mt-8 glass p-5">
                <div className="eyebrow">Fun fact</div>
                <p className="mt-3 text-[15px] text-white/80 leading-relaxed">{active.fact}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 pb-24">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5 stagger">
          {planets.map((p) => (
            <button
              key={p.name}
              onClick={() => { setActive(p); window.scrollTo({ top: 320, behavior: "smooth" }); }}
              className="glass hover-lift p-7 text-left"
              data-testid={`planet-card-${p.name.toLowerCase()}`}
            >
              <div className="planet-sphere mb-5" style={{ width: 80, height: 80, background: p.gradient, "--glow": p.glow }} />
              <div className="eyebrow">{p.type}</div>
              <div className="display mt-3 text-2xl">{p.name}</div>
              <div className="mt-3 text-xs text-white/55">{p.distance}</div>
              <div className="mt-1 text-xs text-white/45">{p.moons} {p.moons === 1 ? "moon" : "moons"}</div>
            </button>
          ))}
        </div>
      </section>
    </>
  );
}

function Spec({ label, value }) {
  return (
    <div>
      <div className="eyebrow">{label}</div>
      <div className="mt-2 text-white text-sm md:text-base">{value}</div>
    </div>
  );
}
